import React, { ReactElement } from 'react'
import { GestureResponderEvent, StyleSheet, View, ViewProps } from 'react-native'

import { Href, Link } from 'zens-router'

import { Color, Spacing } from '../../style'
import { Hyperlink } from '../button'
import { Icon } from '../icon'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  part: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    color: Color.metalGrey,
    textDecorationLine: 'none',
  },
  icon: {
    marginHorizontal: Spacing.XS,
    color: Color.metalGrey,
  },
})

export interface Event extends GestureResponderEvent {
  data: Data
  index: number
}

export interface Data {
  title: string | ReactElement
  onPress?: (event: Event) => void
  href?: Href
}

export interface Props extends ViewProps {
  data?: Data[]
}
const Breadcrumb = (props: Props) => {
  const { data, style, ...otherProps } = props

  const select = (item: Data, index: number) => (event: GestureResponderEvent) => {
    const breadcrumbEvent = { ...event, data: item, index }
    item?.onPress?.(breadcrumbEvent)
  }

  return (
    <View style={[styles.container, style]} {...otherProps}>
      {data?.map((item, index) => {
        const hyperlink = (
          <Hyperlink
            textStyle={styles.text}
            title={item.title}
            testID="Breadcrumb.Part"
            onPress={select(item, index)}
          />
        )
        const content = item.href ? (
          <Link href={item.href} asChild>
            {hyperlink}
          </Link>
        ) : (
          hyperlink
        )
        return (
          <View key={`${item.title}-${index}`} style={styles.part}>
            {content}
            {index < data.length - 1 && <Icon name="right" style={styles.icon} size={12} />}
          </View>
        )
      })}
    </View>
  )
}

export default Breadcrumb
